// This icon file is generated automatically.
var CryptographyOutlined = { "icon": { "tag": "svg", "attrs": { "preserveAspectRatio": "xMidYMid", "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M160.92 90.01l-.38.68a54.26 54.26 0 01-63.15 25.78l-8.46 14.94 10.73 6.31-12.8 22.61-10.72-6.32-3.84 6.79 16.31 9.6-12.79 22.61-16.31-9.6-4.16 7.34-22.34-13.16 41.91-74.07C56.41 86.25 51.26 57.8 64.07 34.78l.39-.68A54.27 54.27 0 01140 13.8c26.45 15.32 35.82 49.45 20.92 76.21zm-32.81-53.08l-.9-.53A28.72 28.72 0 0086.8 47.26a29.95 29.95 0 0010.98 41.13 28.72 28.72 0 0040.41-10.86 29.95 29.95 0 00-10.08-40.6z", "fill-rule": "evenodd" } }] }, "name": "cryptography", "theme": "outlined" };
export default CryptographyOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/CryptographyOutlined.js
// module id = 2357
// module chunks = 0